import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APIRouteMap, LoginAuthApiNamespace } from '@core/models/api';
import { LoginAuthNamespace } from '@core/models/client';

import { map } from 'rxjs';

@Injectable()
export class LoginHttpService {
  private http = inject(HttpClient);


  auth(input: LoginAuthApiNamespace.IN) {
    return this.http
      .post<LoginAuthApiNamespace.OUT>(APIRouteMap.AUTH, input)
      .pipe(
        map((response) => {
          const output = new LoginAuthNamespace.OUT();
          if (response) output.init(response);
          return output;
        })
      );
  }
}
